import React, { useMemo, useRef, useEffect } from 'react';

import socketIOClient from 'socket.io-client';
import SocketContext from './SocketContext';

export const SocketProvider = ({
  children,
  host,
  path,
  autoConnect = true,
  onConnected,
  onDisconnected,
}) => {
  const isConnectedRef = useRef(false);
  const socketRef = useRef(null);

  useMemo(() => {
    const instance = socketIOClient(host, {
      path,
      autoConnect,
      pingTimeout: 30000,
      rememberUpgrade: true,
      transports: ['websocket'],
    });
    socketRef.current = instance;

    instance.prependAny((event, ...args) => {
      // eslint-disable-next-line no-console
      console.log(`got ${event}`, ...args);
    });

    instance.on('connect', () => {
      isConnectedRef.current = true;
      onConnected?.(instance);
    });

    instance.on('disconnect', () => {
      isConnectedRef.current = false;
      onDisconnected?.(socketRef.current);
    });

    instance.on('error', (a) => {
      // eslint-disable-next-line no-console
      console.log('error', a);
    });
  }, []);

  useEffect(() => {
    return () => {
      console.log(`socket unmount disconnect`);
      socketRef.current.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current }}>
      {children}
    </SocketContext.Provider>
  );
};
